import { render, staticRenderFns } from "./GalleriesPricelist.vue?vue&type=template&id=c03c6c9c&scoped=true&"
import script from "./GalleriesPricelist.vue?vue&type=script&lang=js&"
export * from "./GalleriesPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03c6c9c",
  null
  
)

export default component.exports